import React, { useEffect, useRef, useState } from "react";
import { useUser } from "./UserContext";
import WaveSurfer from "wavesurfer.js";
import { Link } from "react-router-dom";
import {
  BsPlayFill,
  BsPauseFill,
  BsArrowDown,
  BsStopFill,
  BsInfoCircle,
  BsSkipForwardFill,
  BsSkipBackwardFill,
} from "react-icons/bs";
import "./css/MiniPlayer.css";
import { FaShoppingCart } from "react-icons/fa";
import { ClipLoader } from "react-spinners";
import AddBeatModal from "./AddBeatModal";
function MiniPlayer({ currentTrack, onTogglePlay, playing }) {
  const { stopCurrentTrack, playNextTrack, playPrevTrack, cart, cartLoading } =
    useUser();
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [volume, setVolume] = useState(1);
  const [infoVisible, setInfoVisible] = useState(false);
  const [selectedBeat, setSelectedBeat] = useState(null);

  const isInCart = (productId) =>
    cart.some((item) => item.productId === productId);
  useEffect(() => {
    if (playing) {
      setIsVisible(true);
    }
  }, [playing]);

  useEffect(() => {
    if (!currentTrack?.lowAudioUrl || !waveformRef.current) return;

    const ws = WaveSurfer.create({
      container: waveformRef.current,
      waveColor: "#9563ff",
      progressColor: "magenta",
      backend: "MediaElement",
      mediaControls: false,
      height: 40,
    });

    wavesurfer.current = ws;

    ws.on("ready", () => {
      ws.setVolume(volume);

      if (playing) {
        Promise.resolve(ws.play()).catch(() => {});
      }
    });

    ws.on("finish", () => {
      playNextTrack();
    });

    ws.load(currentTrack.lowAudioUrl);

    return () => {
      try {
        ws.unAll();
        ws.destroy();
      } catch (err) {
        // ignore WaveSurfer cleanup aborts
      }

      if (wavesurfer.current === ws) {
        wavesurfer.current = null;
      }
    };
  }, [currentTrack, playNextTrack]);
  useEffect(() => {
    if (wavesurfer.current) {
      wavesurfer.current.setVolume(volume);
    }
  }, [volume]);

  useEffect(() => {
    if (!wavesurfer.current) return;

    try {
      if (playing) {
        Promise.resolve(wavesurfer.current.play()).catch(() => {});
      } else {
        wavesurfer.current.pause();
      }
    } catch (err) {
      // ignore route-change / destroy timing noise
    }
  }, [playing]);

  const handleHidePlayer = () => {
    setIsVisible(false);
    stopCurrentTrack();
  };

  const handleVolumeChange = (e) => {
    const newVolume = Number(e.target.value);
    setVolume(newVolume);

    if (wavesurfer.current) {
      wavesurfer.current.setVolume(newVolume);
    }
  };

  const handleStop = () => {
    if (wavesurfer.current) {
      wavesurfer.current.stop();
    }
    stopCurrentTrack();
    setIsVisible(false);
  };

  const toggleInfo = () => setInfoVisible(!infoVisible);

  return (
    <div className={`mini-player-container ${isVisible ? "visible" : ""}`}>
      <div className="waveform-mini" ref={waveformRef}></div>

      <div className="mini-player-row">
        <div className="left-section">
          <Link
            to={`/beats/${currentTrack?.beatName
              ?.replace(/\s+/g, "-")
              .toLowerCase()}`}
          >
            <img src={currentTrack?.imageUrl} className="album-cover" />
          </Link>

          <div className="track-info">
            <Link
              to={`/beats/${currentTrack?.beatName
                ?.replace(/\s+/g, "-")
                .toLowerCase()}`}
            >
              <div className="beat-name-link">{currentTrack?.beatName}</div>
            </Link>
            <div className="track-artist">
              {currentTrack ? currentTrack.artistName : "No Artist"}
            </div>
          </div>
        </div>

        <div className="center-section">
          <button onClick={playPrevTrack} className="play-pause-btn">
            <BsSkipBackwardFill />
          </button>

          <button onClick={onTogglePlay} className="play-pause-btn">
            {playing ? <BsPauseFill /> : <BsPlayFill />}
          </button>

          <button onClick={playNextTrack} className="play-pause-btn">
            <BsSkipForwardFill />
          </button>

          <button onClick={handleStop} className="stop-btn">
            <BsStopFill />
          </button>
        </div>
        <div className="addbtn-section">
          {currentTrack && (
            <div className="cost-cart-info mini-cart-info">
              <button
                className="addCart-button"
                onClick={() => setSelectedBeat(currentTrack)}
                disabled={isInCart(currentTrack.$id)}
              >
                <div className="product-info cost">{` ₹${
                  currentTrack.basicCost || currentTrack.cost
                }`}</div>

                <div className="cartbtn-add">
                  {cartLoading[currentTrack.$id] ? (
                    <ClipLoader size={7} color="#FFF" />
                  ) : isInCart(currentTrack.$id) ? (
                    <>
                      In <FaShoppingCart />
                    </>
                  ) : (
                    <>
                      Add <FaShoppingCart />
                    </>
                  )}
                </div>
              </button>
            </div>
          )}
        </div>
        <div className="right-section">
          <input
            type="range"
            className="volume-slider"
            min="0"
            max="1"
            step="0.01"
            value={volume}
            onChange={handleVolumeChange}
          />

          <button onClick={handleHidePlayer} className="control-btn">
            <BsArrowDown />
          </button>

          <button onClick={toggleInfo} className="info-btn">
            <BsInfoCircle />
          </button>

          {infoVisible && (
            <div className="info-message">
              This audio playing is a low-quality file. After buying, the full
              quality file will be available.
            </div>
          )}
        </div>
      </div>

      {selectedBeat && (
        <AddBeatModal
          product={selectedBeat}
          onClose={() => setSelectedBeat(null)}
        />
      )}
    </div>
  );
}

export default MiniPlayer;
